import {
  ChangeDetectorRef,
  Component,
  ComponentRef,
  ElementRef,
  OnInit,
  Type,
  ViewChild,
  ViewContainerRef,
} from '@angular/core';
import { ComponentRegister, ComponentRegistry } from '../../helpers/component-register';
import { ArenaService } from '.././arena.service';
import { AbcArenaService, DataFormatTheme, DataFormStyle } from '../../abc-arena.service';
import { ResourceManager } from '@barthauer/abc/core/resources';
// import { UserPersonInfo, UserPersonInfoService, UserService } from '@barthauer/basys/core/authentication';
import { UserPersonInfo, UserPersonInfoService, UserService } from '@barthauer/abc/core/authentication';
import { _AbcSwitchComponent, AbcComponentService, StylingMode, ToastType } from '@barthauer/abc/ui-components';
import { IDataFormSettings } from '../models/dataform-settings.model';
import { DataFormSettingsService } from '../../services/dataform-settings.service';
import { ThemeService } from '../../services/theme.service';
import {
  BooleanMenuSetting,
  SettingsPageEnum,
  AdditionalMenuSettingItem,
  SettingsChangingEvent,
  SettingsCancellingEvent,
} from './setting.model';
import { AbcCore, ConvertHelper, overrideDefaultRootColors } from '@barthauer/abc/core';
import { ParameterValue } from '@barthauer/abc/queries/parameters/core';
import { lastValueFrom, firstValueFrom } from 'rxjs';
import { BuildInfoService } from '@barthauer/abc/core/setup-info';
import { AuthConfigService, LoginInfo } from '@barthauer/basys/core/authentication';
import { UserSettingsComponent } from '@barthauer/abc/management/users';
import { formatMessage } from 'devextreme/localization';

import {
  DialogResult,
  MessageBoxButtons,
  MessageBoxIcon,
  MessageMode,
  MessageSettings,
  MessageBoxService,
} from '@barthauer/abc/messages';
import { AppSettingsService } from '../../services/app-settings.service';
import { Item as dxTreeViewItem } from 'devextreme/ui/tree_view';
import { DxTreeViewTypes } from 'devextreme-angular/ui/tree-view';
import { DxSwitchTypes } from 'devextreme-angular/ui/switch';
import { AbcConfigService } from '@barthauer/abc/core/configuration';

export interface CustomTabPanelItem extends dxTreeViewItem {
  index: number;
  id: string | number;
  parentId?: string | number;
  items?: CustomTabPanelItem[];
  component?: Type<any> | null;
  type?: SettingsPageEnum;
}

export type SettingsItemComponent = {
  componentRef: ComponentRef<unknown>;
  domElement: HTMLElement;
};
export type StyleColors = { [key: string]: string };
export type StyleDataForm = { MaxHeightOfEmptyRows?: string };
export type StyleConfig = {
  Mode?: StylingMode;
  LabelMode?: string;
  Colors?: StyleColors;
  DataForm?: StyleDataForm;
  Designation?: string;
};
export type LabeledValue = { value: string; label: string };
export type StyleSettingInput =
  | string
  | {
      value?: string;
      id?: string;
      Name?: string;
      Description?: string;
      label?: string;
    };

@ComponentRegistry('SettingsComponent')
@Component({
  selector: 'arena-settings',
  templateUrl: './settings.component.html',
  styleUrls: ['./settings.component.scss'],
  standalone: false,
})
export class SettingsComponent implements OnInit {
  @ViewChild('fileInput', { static: false })
  fileInput: ElementRef<HTMLInputElement>;
  @ViewChild('dynamicHost', { read: ViewContainerRef, static: false })
  public dynamicHost: ViewContainerRef;
  @ViewChild('additionalSettingsItem', {
    read: ViewContainerRef,
    static: false,
  })
  public additionalSettingsItem: ViewContainerRef;
  @ViewChild('userSettings', { static: false })
  public userSettingsComponent?: UserSettingsComponent;
  public translator = ResourceManager.getResources('abc-arena');
  private formatMessage: (key: string, ...values: Array<string>) => string = formatMessage;
  public SettingsPageEnum = SettingsPageEnum;
  public settingsPage: SettingsPageEnum = SettingsPageEnum.UserInfo || SettingsPageEnum.General;
  public requiresPageRefresh = false;
  public hasPendingChanges = false;
  public selectedAccountLnguage: string;
  private originalAccountLanguage: string;

  public selectedTheme: string;
  public selectedDisplayMode: DataFormStyle;
  public selectedLayoutSplitterOrientation: 'vertical' | 'horizontal';

  public originalDisplayMode: DataFormStyle;
  public originalLayoutSplitterOrientation: 'vertical' | 'horizontal';
  public originalTheme: string;
  public originalStylingMode: StylingMode;
  public selectedStyleMode: StylingMode;
  public selectedAdditionalTab: CustomTabPanelItem;
  public openedTab: string | null = null;
  public selectedAdditionalComponent: Type<any> | null = null;
  protected versionInfo: string;
  protected buildNumber: string;
  protected buildDate: string;
  protected isLanguageDisabled = false;
  protected settingsTabsItems: CustomTabPanelItem[] = [
    {
      id: SettingsPageEnum.General,
      text: this.translator('Arena-General'),
      icon: 'arena-setting',
      index: 0,
    },
    {
      id: SettingsPageEnum.Layout,
      text: this.translator('Arena-Layout'),
      icon: 'layout',
      index: 1,
    },
    {
      id: SettingsPageEnum.UserInfo,
      text: this.translator('Arena-UserInfo'),
      icon: 'user-setting',
      index: 2,
    },
    {
      id: SettingsPageEnum.Version,
      text: this.translator('Arena-version'),
      icon: 'arenaGeneral',
      index: 9999,
    },
  ];
  public activeTab: CustomTabPanelItem;

  protected tooltipTarget: any;
  protected tooltipContent: string = '';
  protected tooltipVisible: boolean = false;

  private additionalMenuSettingItems: AdditionalMenuSettingItem[];
  private settingsItemsMap: Map<
    string,
    {
      componentRef: ComponentRef<unknown>;
      domElement: HTMLElement;
    }
  > = new Map();

  public selectedFile: File | null = null;
  public styleConfig: StyleColors = null;
  public selectedStylingOption: string = '';
  public originalStylingOption: string = '';
  public StyleSettings: StyleSettingInput[];
  public arenaStylingData: LabeledValue[] = [];
  private settingsChangingEvents: Map<string, SettingsChangingEvent> = new Map();
  private settingsCancellingEvents: Map<string, SettingsCancellingEvent> = new Map();
  private isSaved = false;
  protected errorMessageText: string = '';

  public languageOptions: { Value: string; Description: string }[] = [
    {
      Value: 'de',
      Description: this.translator('Arena-German'),
    },
    {
      Value: 'en',
      Description: this.translator('Arena-English'),
    },
    {
      Value: 'fr',
      Description: this.translator('Arena-France'),
    },
    {
      Value: 'pt',
      Description: this.translator('Arena-Portuguese'),
    },
    {
      Value: 'sp',
      Description: this.translator('Arena-Spanish'),
    },
  ];
  public dropdownLanguagesGridColumns = [
    { dataField: 'Value', caption: 'Value' },
    { dataField: 'Description', caption: 'Description' },
  ];

  generalDropdownGridColumns = [{ dataField: 'label' }];

  public themeOptions = [
    {
      value: DataFormatTheme.DEFAULT,
      label: this.translator('Arena-Default'),
    },
    {
      value: DataFormatTheme.COMPACT,
      label: this.translator('Arena-Compact'),
    },
  ];

  public displayStyleOptions = [
    {
      value: DataFormStyle.GALLERY,
      label: this.translator('Arena-data-form-gallery'),
    },
    {
      value: DataFormStyle.ACCORDION,
      label: this.translator('Arena-data-form-accordion'),
    },
    {
      value: DataFormStyle.TABS,
      label: this.translator('Arena-data-form-tabs'),
    },
  ];

  public stylingModeOptions = [
    {
      label: this.translator('Arena-data-form-StylingMode-Underlined'),
      value: 'underlined',
    },
    {
      label: this.translator('Arena-data-form-StylingMode-Outlined'),
      value: 'outlined',
    },
    {
      label: this.translator('Arena-data-form-StylingMode-Filled'),
      value: 'filled',
    },
  ];

  public layoutSplitterOrientationOptions = [
    {
      label: this.translator('Arena-data-form-LayoutSplitterOrientation-Vertical'),
      value: 'vertical',
    },
    {
      label: this.translator('Arena-data-form-LayoutSplitterOrientation-Horizontal'),
      value: 'horizontal',
    },
  ];

  public errorMessage: string;

  constructor(
    protected arenaService: ArenaService,
    private _abcComponent: AbcComponentService,
    public userService: UserService,
    private dataFormSettingsService: DataFormSettingsService,
    protected themeService: ThemeService,
    protected buildInfoService: BuildInfoService,
    private abcArenaService: AbcArenaService,
    private cd: ChangeDetectorRef,
    private abcCore: AbcCore,
    private messageBoxService: MessageBoxService,
    private appSettingsService: AppSettingsService,
    private authConfigService: AuthConfigService,
    private configService: AbcConfigService,
  ) {}

  public async ngOnInit() {
    this.activeTab = this.settingsTabsItems[0];
    await this.initFormValues();
    this.initSettingsTabs();
    await this.getDataFormLayoutSettings();
    await this.loadTheColorSchemas();
    this.setAdditionalPageItems();
  }

  private async getDataFormLayoutSettings() {
    try {
      const current = (await lastValueFrom(this.dataFormSettingsService.getCurrentSettings())) as IDataFormSettings;
      const colorSchemaConfig = await lastValueFrom(this.appSettingsService.getCurrentSettings());

      this.originalStylingMode =
        this.selectedStyleMode =
        this.abcComponent.stylingMode =
          current?.style['stylingMode'] as StylingMode;
      this.originalDisplayMode = this.selectedDisplayMode = current?.style['tabs'] || DataFormStyle.TABS;
      this.originalLayoutSplitterOrientation = this.selectedLayoutSplitterOrientation =
        current?.style['orientation'] || 'vertical';
      this.originalTheme = this.selectedTheme = current?.theme ?? DataFormatTheme.DEFAULT;
      this.originalStylingOption = this.selectedStylingOption = colorSchemaConfig?.lastStyleName ?? 'default';
    } catch (error) {
      this.abcCore.error.publish(error);
      this.showErrorMessage(this.translator('Arena-settings-DataLoading-error'));
    }
  }

  protected onItemClick(e: DxTreeViewTypes.ItemClickEvent) {
    this.activeTab = e.itemData;
    if (this.activeTab.type === SettingsPageEnum.Additional) {
      this.showAdditionalSettings(this.activeTab);
    }
  }

  private async initFormValues() {
    try {
      // ? set Language Data
      const userLanguage = await this.userService.getAccountLanguage();
      const storedLanguage = localStorage.getItem('currentAccountLanguage');
      const configLanguage = await lastValueFrom(this.authConfigService.current);
      if (configLanguage.fixedCulture) {
        this.isLanguageDisabled = true;
      }
      this.selectedAccountLnguage = this.originalAccountLanguage =
        configLanguage.fixedCulture || userLanguage || storedLanguage;

      // ? set System information Data
      this.versionInfo = this.buildInfoService.getMainVersion();
      this.buildNumber = this.buildInfoService.getFullVersion();
      this.buildDate = this.buildInfoService.getBuildDate();
      this.cd.detectChanges();
    } catch (error) {
      this.abcCore.error.publish(error);
      this.showErrorMessage(this.translator('Arena-settings-DataLoading-error'));
    }
  }

  private initSettingsTabs(): void {
    const additionalSettingsTabs = this.abcArenaService.additionalSettingsTabs ?? [];
    additionalSettingsTabs.forEach((tab) => {
      const exists = this.settingsTabsItems.some((item) => item.text === tab.name);
      if (!exists) {
        this.settingsTabsItems.push({
          text: tab.name,
          icon: tab.svgIcon,
          index: tab.visibleIndex,
          id: tab.name,
          type: SettingsPageEnum.Additional,
          component: tab.component,
          parentId: tab?.ParentId || null,
        });
      }
    });
    this.settingsTabsItems.sort((a, b) => {
      const ai = Number(a.index);
      const bi = Number(b.index);

      if (isNaN(ai)) return isNaN(bi) ? 0 : 1;
      if (isNaN(bi)) return -1;

      return ai - bi;
    });
  }

  private async showAdditionalSettings(tab?: CustomTabPanelItem, index?: number) {
    this.settingsPage = (tab?.id as SettingsPageEnum) || this.settingsPage;
    this.selectedAdditionalTab = tab;

    if (tab) {
      this.openedTab = this.openedTab === tab.text ? null : tab.text;

      await this.openAdditionalSettingsItem(tab);
      setTimeout(() => {
        this.setAdditionalPageItems();
      });
      return;
    }

    this.openedTab = null;
    if (this.dynamicHost) this.dynamicHost.clear();
    this.selectedAdditionalComponent = null;
    this.selectedAdditionalTab = null;

    const first = this.settingsTabsItems?.length ? this.settingsTabsItems[index] : null;
    if (first) {
      this.openedTab = first.text;
      await this.openAdditionalSettingsItem(first);
    } else {
      this.openedTab = null;
      if (this.dynamicHost) this.dynamicHost.clear();
      this.selectedAdditionalComponent = null;
      this.selectedAdditionalTab = null;
    }
  }

  private setAdditionalPageItems() {
    this.additionalMenuSettingItems = this.abcArenaService.additionalMenuSettingItems;
    if (this.additionalMenuSettingItems?.length > 0) {
      this.additionalMenuSettingItems.forEach((item) => {
        const parentIdName = ConvertHelper.getEnumKeyByEnumValue(SettingsPageEnum, item.parentVisibleIndex);
        const parentDiv = document.getElementById(parentIdName);
        if (parentDiv) {
          if (item instanceof BooleanMenuSetting) {
            this.setBooleanMenuSettings(item, parentDiv);
          }
          this.cd.detectChanges();
        }
      });
    }
  }

  private getSettingsItemKey(item: Pick<BooleanMenuSetting, 'parentVisibleIndex' | 'visibleIndex'>): string {
    return `${item.parentVisibleIndex}-${item.visibleIndex}`;
  }
  private setBooleanMenuSettings(item: BooleanMenuSetting, parentDiv: HTMLElement): void {
    const itemKey = this.getSettingsItemKey(item);
    const component = this.getOrCreateSwitchComponent(item, itemKey);

    component.domElement.classList.add('dx-show-invalid-badge', 'notification-settings-switch');

    const wrapper = this.getOrCreateSettingWrapper(item, component, parentDiv);

    if (!parentDiv.contains(wrapper)) {
      parentDiv.appendChild(wrapper);
    }

    setTimeout(() => {
      if (component.domElement.parentElement) {
        component.domElement.remove();
      }

      const row = wrapper.querySelector<HTMLElement>('.notification-settings-row');
      if (row && !row.contains(component.domElement)) {
        row.appendChild(component.domElement);
      }
    }, 0);
  }

  private getOrCreateSwitchComponent(item: BooleanMenuSetting, itemKey: string): SettingsItemComponent {
    const cached = this.settingsItemsMap.get(itemKey);
    if (cached) {
      return cached;
    }

    return this.createAndRegisterSwitchComponent(item, itemKey);
  }

  private createAndRegisterSwitchComponent(item: BooleanMenuSetting, itemKey: string): SettingsItemComponent {
    const component = this.arenaService.loadComponent(_AbcSwitchComponent, this.additionalSettingsItem);

    const instance = component.componentRef.instance as _AbcSwitchComponent;
    const initialValue = Boolean(item.value);

    instance.value = initialValue;
    instance.switchedOffText = '';
    instance.switchedOnText = '';

    if (item.onBeforeCancel) {
      const cancelEvent = new SettingsCancellingEvent();
      cancelEvent.cancel = item.onBeforeCancel;
      this.settingsCancellingEvents.set(itemKey, cancelEvent);
    }

    let changingEvent = new SettingsChangingEvent(initialValue);

    instance.onValueChanged.subscribe((e: DxSwitchTypes.ValueChangedEvent) => {
      item.valueChanged(e);

      if (this.isSaved) {
        changingEvent = new SettingsChangingEvent(e.previousValue);
      }
      changingEvent.value = e.value;
      this.hasPendingChanges = changingEvent.isChanged();
      this.errorMessageText = '';

      if (item.onBeforeSave) {
        changingEvent.cancel = item.onBeforeSave;
      }

      this.settingsChangingEvents.set(itemKey, changingEvent);
    });

    this.settingsItemsMap.set(itemKey, component);

    return component;
  }

  private getOrCreateSettingWrapper(
    item: BooleanMenuSetting,
    component: SettingsItemComponent,
    parentDiv: HTMLElement,
  ): HTMLElement {
    const existingWrapper = parentDiv.querySelector<HTMLElement>(`#${item.name}-wrapper`);

    if (existingWrapper) {
      this.syncComponentIntoWrapper(existingWrapper, component);
      return existingWrapper;
    }

    return this.buildSettingWrapper(item, component);
  }

  private syncComponentIntoWrapper(wrapper: HTMLElement, component: SettingsItemComponent): void {
    const row = wrapper.querySelector<HTMLElement>('.notification-settings-row');
    if (!row) return;

    const orphanedComponent = row.querySelector('.dx-show-invalid-badge');
    if (orphanedComponent && orphanedComponent !== component.domElement) {
      orphanedComponent.remove();
    }

    if (!row.contains(component.domElement)) {
      row.appendChild(component.domElement);
    }
  }

  private buildSettingWrapper(item: BooleanMenuSetting, component: SettingsItemComponent): HTMLElement {
    const label = document.createElement('h4');
    label.className = 'section-title';
    label.innerText = this.translator(item.caption);

    const descriptionEl = this.getOrCreateDescriptionElement(item);

    const descriptionContainer = document.createElement('div');
    descriptionContainer.className = 'notification-settings-description';
    descriptionContainer.appendChild(descriptionEl);

    const row = document.createElement('div');
    row.className = 'notification-settings-row';
    row.appendChild(descriptionContainer);

    const mainContainer = document.createElement('div');
    mainContainer.id = item.name;
    mainContainer.className = 'tab-content-section';
    mainContainer.appendChild(label);
    mainContainer.appendChild(row);

    const wrapper = document.createElement('div');
    wrapper.id = `${item.name}-wrapper`;
    wrapper.className = 'notification-settings-container';
    wrapper.appendChild(mainContainer);

    return wrapper;
  }

  private getOrCreateDescriptionElement(item: BooleanMenuSetting): HTMLElement {
    const descriptionId = `${item.name}-Description`;
    const existing = document.getElementById(descriptionId);

    if (existing) {
      existing.className = 'notification-settings-description-text';
      return existing;
    }

    const description = document.createElement('div');
    description.id = descriptionId;
    description.className = 'notification-settings-description-text';
    description.innerText = this.translator(`${item.caption}-Description`);
    return description;
  }

  private async openAdditionalSettingsItem(tab: CustomTabPanelItem) {
    const isTopLevel = this.settingsTabsItems?.some((t) => t?.text === tab?.text);
    if (isTopLevel) {
      this.selectedAdditionalTab = tab;
    }

    if (tab.component === null) {
      this.selectedAdditionalComponent = null;
      if (this.dynamicHost) this.dynamicHost.clear();
      return;
    }
    let compType: Type<any> | null = null;

    try {
      const spec: any = tab?.component;

      // 1) Direct Type/class
      if (typeof spec === 'function') {
        compType = spec as Type<any>;

        // 2) Registry key
      } else if (typeof spec === 'string') {
        const cre = ComponentRegister.get(spec);
        compType = cre?.component ?? null;
        if (!compType) console.warn(`ComponentRegister has no entry for '${spec}'`);

        // 3) Descriptor object: { type }, or { modulePath, exportName }
      } else if (spec && typeof spec === 'object') {
        if (spec.type && typeof spec.type === 'function') {
          compType = spec.type as Type<any>;
        } else if (spec.modulePath && typeof spec.modulePath === 'string') {
          try {
            const mod = await import(/* webpackIgnore: false */ spec.modulePath);
            const exportName = spec.exportName || spec.export || 'default';
            compType = mod[exportName] ?? mod.default ?? null;
            if (!compType) console.warn(`Module loaded but export '${exportName}' not found in ${spec.modulePath}`);
          } catch (err) {
            console.warn(`Dynamic import failed for ${spec.modulePath}:`, err);
          }
        }
      }
    } catch (err) {
      console.error('Error resolving additional settings component:', err);
      this.showErrorMessage('Failed to load settings component. Please try again later.');
    }

    this.selectedAdditionalComponent = compType;
    if (compType && this.dynamicHost) {
      this.dynamicHost.clear();
      this.dynamicHost.createComponent(compType);
      this.cd.markForCheck();
    }
  }

  protected handleChangeStates(): void {
    this.requiresPageRefresh =
      this.selectedAccountLnguage !== this.originalAccountLanguage ||
      this.selectedDisplayMode !== this.originalDisplayMode ||
      this.selectedLayoutSplitterOrientation !== this.originalLayoutSplitterOrientation ||
      this.selectedStyleMode !== this.originalStylingMode;

    this.hasPendingChanges =
      this.selectedTheme !== this.originalTheme || this.selectedStylingOption !== this.originalStylingOption;
    this.errorMessageText = '';
    this.cd.detectChanges();
  }

  protected async cancel(): Promise<void> {
    try {
      this.requiresPageRefresh = false;
      await Promise.all(
        [...this.settingsCancellingEvents.values()].map(async (scae) => {
          try {
            await scae.cancel?.();
          } catch (err) {
            console.error('error here', err);
            throw err;
          }
        }),
      );
      if (this.settingsPage === SettingsPageEnum.Password && this.userSettingsComponent) {
        this.userSettingsComponent.cancelPasswordChange();
        return;
      }
      const windowInstance: any = this._abcComponent.getInstanceById('window');
      if (windowInstance && typeof windowInstance.closeDialog === 'function') {
        windowInstance.closeDialog();
      }
    } catch (err) {
      console.error('error', err);
    }
  }

  protected async save(): Promise<void> {
    try {
      const requests: Promise<unknown>[] = [];

      const nextSettings: IDataFormSettings = {
        style: {
          tabs: this.selectedDisplayMode,
          orientation: this.selectedLayoutSplitterOrientation,
          stylingMode: this.selectedStyleMode,
        },
        theme: this.selectedTheme as DataFormatTheme,
      };

      // Validate/cancel pending changes
      await Promise.all(
        [...this.settingsChangingEvents.values()].map(async (event) => {
          try {
            await event?.cancel?.();
          } catch (error) {
            console.error('notif', event.errorMessage);

            console.error('Settings change validation failed:', error);
            throw error;
          }
        }),
      );

      // Sync runtime configuration
      this.syncRuntimeConfiguration();

      // Save form settings
      requests.push(firstValueFrom(this.dataFormSettingsService.setCurrentSettings(nextSettings)));

      // Save language if changed
      if (this.originalAccountLanguage !== this.selectedAccountLnguage) {
        requests.push(this.userService.setAccountLanguage(this.selectedAccountLnguage));
      }

      // Save user settings
      if (this.userSettingsComponent.isUserChanged && this.userSettingsComponent.isUserValid) {
        this.userSettingsComponent.saveUser();
      }

      // Save styles
      requests.push(this.saveColorSchema());

      // Wait all saves
      await Promise.all(requests);

      // Apply theme after successful save
      this.themeService.applyTheme(this.selectedTheme);

      this.arenaService.settingsChanged();

      this.updateOriginalValues();
      this.cd.detectChanges();
      this.isSaved = true;
      this.refresh();
    } catch (error) {
      console.error('Save failed:', error);
      this.isSaved = false;
      this.errorMessageText = this.translator('Arena-settings-save-error');
      this.abcCore.error.publish(error);
    }
  }

  private syncRuntimeConfiguration(): void {
    this.arenaService.uiconfig.dataFormStyle = this.selectedDisplayMode as DataFormStyle;

    this.arenaService.uiconfig.layoutSplitterOrientation = this.selectedLayoutSplitterOrientation as any;

    this.arenaService.uiconfig.theme = this.selectedTheme as DataFormatTheme;

    this.arenaService.uiconfig.stylingMode = this.selectedStyleMode as StylingMode;
  }

  private updateOriginalValues(): void {
    this.originalDisplayMode = this.selectedDisplayMode;

    this.originalLayoutSplitterOrientation = this.selectedLayoutSplitterOrientation;

    this.originalTheme = this.selectedTheme;

    this.originalStylingMode = this.abcComponent.stylingMode;
    this.originalStylingOption = this.selectedStylingOption;
  }

  private refresh() {
    if (this.requiresPageRefresh) {
      window.location.reload();
    }
    this.requiresPageRefresh = false;
    this.hasPendingChanges = false;
    this.errorMessageText = '';
  }

  protected async copyToClipboard(text: string): Promise<void> {
    if (navigator.clipboard && window.isSecureContext) {
      try {
        await navigator.clipboard.writeText(text);
        return;
      } catch (err) {
        console.error('Clipboard API failed', err);
      }
    }
  }
  public onUserInfoChanged(): void {
    this.arenaService.settingsChanged();
    this.hasPendingChanges = true;
    this.errorMessageText = '';
  }

  get abcComponent() {
    return this._abcComponent;
  }

  private showErrorMessage(message: string): void {
    this.arenaService.notificationSubject.next({
      type: ToastType.Error,
      message: message,
    });
  }

  protected async onFileSelected(event: Event): Promise<void> {
    try {
      const target = event.target as HTMLInputElement;

      if (!target.files?.length) {
        return;
      }

      const file = target.files[0];
      target.value = '';

      if (!file.name.toLowerCase().endsWith('.json')) {
        this.showErrorMessage(this.translator('Arena-Settings-FileUpload-Json-error'));
        return;
      }

      const content = await this.readFileText(file);

      let parsed: unknown;

      try {
        parsed = JSON.parse(content);
      } catch {
        this.showErrorMessage(this.translator('Arena-Settings-FileUpload-Json-format-error'));
        return;
      }

      const validation = this.validateStyleFile(parsed);

      if (!validation.valid) {
        this.showErrorMessage(validation.message ?? this.translator('Arena-Settings-FileUpload-Validation-error'));
        return;
      }

      await this.processStyleUpload(file, parsed as StyleColors);
    } catch (error) {
      this.abcCore.error.publish(error);
    }
  }

  private validateStyleFile(parsed: unknown): {
    valid: boolean;
    message?: string;
  } {
    // Must be a flat object
    if (!parsed || typeof parsed !== 'object' || Array.isArray(parsed)) {
      return {
        valid: false,
        message: this.translator('Arena-Settings-FileUpload-Json-flat-format-error'),
      };
    }

    const entries = Object.entries(parsed);

    // Cannot be empty
    if (entries.length === 0) {
      return {
        valid: false,
        message: this.translator('Arena-Settings-FileUpload-Json-empty-error'),
      };
    }

    for (const [key, value] of entries) {
      if (typeof value === 'object') {
        return {
          valid: false,
          message: this.formatMessage('Arena-Settings-FileUpload-Json-nested-error', key),
        };
      }

      if (value == null) {
        return {
          valid: false,
          message: this.formatMessage('Arena-Settings-FileUpload-Json-null-error', key),
        };
      }

      if (typeof value !== 'string') {
        return {
          valid: false,
          message: this.formatMessage('Arena-Settings-FileUpload-Json-string-error', key),
        };
      }

      if (!this.isValidStyleValue(value)) {
        return {
          valid: false,
          message: this.formatMessage('Arena-Settings-FileUpload-Json-invalid-style-value-error', key),
        };
      }
    }

    return { valid: true };
  }

  private isValidStyleValue(value: string): boolean {
    const v = value.trim();
    const isHex = /^#([A-Fa-f0-9]{3}|[A-Fa-f0-9]{6})$/.test(v);
    const isRgb = /^rgba?\(\s*\d+\s*,\s*\d+\s*,\s*\d+(\s*,\s*(0|1|0?\.\d+))?\s*\)$/.test(v);
    const isHsl = /^hsla?\(/.test(v);
    const isCssVar = v.startsWith('var(');
    const isKeyword = ['transparent', 'inherit', 'initial', 'unset'].includes(v);

    return isHex || isRgb || isHsl || isCssVar || isKeyword;
  }

  private async processStyleUpload(file: File, parsedStyle: StyleColors): Promise<void> {
    try {
      this.selectedFile = file;
      const previousSelection = this.selectedStylingOption;
      const baseName = this.getFileBaseName(file?.name ?? '');
      this.selectedStylingOption = baseName;
      this.styleConfig = parsedStyle;

      const exists = this.styleExists(baseName);
      if (exists) {
        const choice = await this.confirmOverride();
        if (choice === 'no') {
          let last = previousSelection;
          if (!last) {
            const settings = await lastValueFrom(this.appSettingsService.getCurrentSettings());
            last = settings?.lastStyleName ?? 'Default';
          }

          this.selectedStylingOption = last;
          this.selectedFile = null;

          if (this.fileInput?.nativeElement) {
            this.fileInput.nativeElement.value = '';
          }

          return;
        }
      } else {
        this.arenaStylingData.push({
          value: this.selectedStylingOption,
          label: this.selectedStylingOption,
        });
      }

      this.handleChangeStates();
    } catch (error) {
      this.abcCore.error.publish(error);
    }
  }
  private async readFileText(file: File): Promise<string> {
    return await new Promise<string>((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => resolve(reader.result as string);
      reader.onerror = () => reject(reader.error);
      reader.readAsText(file);
    });
  }

  private getFileBaseName(name: string): string {
    return name.replace(/\.[^/.]+$/, '');
  }

  private styleExists(designation: string): boolean {
    return this.arenaStylingData.some((item) => item.label === designation);
  }

  private async confirmOverride(): Promise<'yes' | 'no'> {
    const settings: MessageSettings = {
      mode: MessageMode.Question,
      caption: this.translator('Arena-Styling'),
      message: this.translator('Arena-StyleExistsOverride'),
      button: MessageBoxButtons.YesNo,
      icon: MessageBoxIcon.Question,
      errorMessage: '',
    };
    const result: any = await firstValueFrom(this.messageBoxService.showMessageBox(settings));
    const val: any =
      typeof result === 'number'
        ? result
        : typeof result === 'string'
          ? (result as string).toLowerCase()
          : (result?.result ?? result);
    const isYes = val === DialogResult.Yes || val === 'yes' || val === 'ok' || val === true;
    return isYes ? 'yes' : 'no';
  }

  private async loadTheColorSchemas() {
    if (!this.StyleSettings) {
      this.StyleSettings = ConvertHelper.arrayBufferToObjectArray<string>(
        await lastValueFrom(this.abcCore.data.executeGetPublicNamesQuery(new ParameterValue('StyleSettings'))),
      );
    }
    if (this.StyleSettings && this.StyleSettings.length > 0) {
      this.arenaStylingData = this.StyleSettings.map((setting: string) => {
        return { value: setting, label: setting } as LabeledValue;
      });
    }
    const hasDefault = this.arenaStylingData.some((s) => s.value.toLowerCase() === 'default');
    if (!hasDefault)
      this.arenaStylingData.unshift({
        value: 'default',
        label: this.translator('Arena-Default'),
      });
  }

  /**
   * Saves the current style configuration based on the selected styling option.
   * Handles three scenarios:
   * 1. Reset to default: Clears all custom styles and reverts to default settings.
   * 2. Save new uploaded style: Persists a newly uploaded style file to both database and local storage.
   * 3. Load existing style: Retrieves and applies a previously saved style from the database.
   * Updates UI data collections, persists settings to storage, and applies the style configuration visually.
   */
  public async saveColorSchema(): Promise<void> {
    try {
      const currentSettings = await lastValueFrom(this.appSettingsService.getCurrentSettings());

      const styleSettings: {
        Colors?: StyleColors;
      } = currentSettings?.arenaStyleSettings ? JSON.parse(currentSettings.arenaStyleSettings) : {};

      // Reset to default style
      if (this.selectedStylingOption === 'default') {
        await this.handleDefaultStyle();
        return;
      }

      // Uploaded custom style
      if (this.styleConfig && this.selectedFile) {
        await this.handleUploadedStyle(styleSettings);
        return;
      }

      // Existing saved style
      if (this.selectedStylingOption) {
        await this.handleStoredStyle(styleSettings);
      }
    } catch (error) {
      this.abcCore.error.publish(error);
    }
  }

  private async handleDefaultStyle(): Promise<void> {
    try {
      const defaultColors = this.configService.getConfiguration().Style.Colors;
      overrideDefaultRootColors({
        Style: { Colors: defaultColors },
      });
      this.styleConfig = null;
      localStorage.removeItem('ArenaStyleSettings');

      await lastValueFrom(
        this.appSettingsService.setCurrentSettings({
          lastStyleName: 'default',
          arenaStyleSettings: '',
        }),
      );
    } catch (error) {
      this.abcCore.error.publish(error);
    }
  }

  private async handleUploadedStyle(styleSettings: { Colors?: StyleColors }): Promise<void> {
    styleSettings.Colors = this.styleConfig;

    overrideDefaultRootColors({
      Style: {
        Colors: this.styleConfig,
      },
    });

    const serializedSettings = JSON.stringify(styleSettings);

    localStorage.setItem('ArenaStyleSettings', serializedSettings);

    await lastValueFrom(
      this.abcCore.data.executeSetValueQuery(
        new ParameterValue('StyleSettings', serializedSettings, this.selectedStylingOption),
      ),
    );
    this.selectedFile = null;
    await this.persistStyleSettings(this.selectedStylingOption, serializedSettings);
  }

  private async handleStoredStyle(styleSettings: { Colors?: StyleColors }): Promise<void> {
    const styleBuffer = await lastValueFrom(
      this.abcCore.data.executeGetValueQuery(
        new ParameterValue('StyleSettings', JSON.stringify(styleSettings), this.selectedStylingOption),
      ),
    );

    const loadedStyle = ConvertHelper.arrayBufferToObject<{
      Style?: StyleConfig;
      Colors?: StyleColors;
    }>(styleBuffer);

    if (!loadedStyle?.Colors) {
      return;
    }

    styleSettings.Colors = loadedStyle.Colors;

    overrideDefaultRootColors({
      Style: loadedStyle,
    });

    const serializedSettings = JSON.stringify(styleSettings);

    localStorage.setItem('ArenaStyleSettings', serializedSettings);

    await this.persistStyleSettings(this.selectedStylingOption, serializedSettings);
  }

  private async persistStyleSettings(styleName: string, serializedSettings: string): Promise<void> {
    await lastValueFrom(
      this.appSettingsService.setCurrentSettings({
        lastStyleName: styleName,
        arenaStyleSettings: serializedSettings,
      }),
    );
  }

  protected showTooltip(event: MouseEvent, nodeData: any) {
    const target = event.currentTarget as HTMLElement;

    const textElement = target.querySelector('.tab-title-text') as HTMLElement;

    if (textElement && textElement.offsetWidth > 0) {
      return;
    }

    this.tooltipTarget = target;
    this.tooltipContent = nodeData.text;
    this.tooltipVisible = true;
  }

  protected hideTooltip() {
    this.tooltipVisible = false;
  }
}
